export default __webpack_public_path__ + "static/media/screen7.d73ed53e.png";